import { Card, CardBody, CardHeader, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import Swal from 'sweetalert2'
import DataTable from 'react-data-table-component';
import "react-datepicker/dist/react-datepicker.css";
import React, { useEffect, useState, useContext } from "react";
import { UserContext } from '../../../context/UserProvider';
import Filtro from '../../../componentes/filtro';
import * as XLSX from "xlsx"
import { FormatMoney } from 'format-money-js'
import filtro from "../../../componentes/filtro";
import Movimientos from '../../Venta'
import InteligenciaArtificial from '../../InteligenciaArtificial';
const tabespacio = '\u00A0';

const modeloInicio = [{
    referencia: "",
    descripcion: "",
    bodega: "",
    existencia: ""

}]

const ReporteVenta = (props) => {
    const [fechaInicio, setFechaInicio] = useState(new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2));
    const [fechaFin, setFechaFin] = useState(new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2));
    const [fechahoy, setfechahoy] = useState(new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2));

    const [pendiente, setPendiente] = useState(false);
    const [concepto, setconcepto] = useState(false);
    const [tercero, settercero] = useState(false);
    const [vendedor, setvendedor] = useState(false);
    const [filtros, setfiltros] = useState(false);
    const [ventas, setVentas] = useState(modeloInicio)
    const [ventasconceptos, setventasconceptos] = useState(modeloInicio)
    const [ventasterceros, setventasterceros] = useState(modeloInicio)
    const [ventasvendedor, setventasvendedor] = useState(modeloInicio)
    const { user, cerrarSession } = useContext(UserContext);
    const [fm, setfm] = useState(new FormatMoney({ symbol: '', decimals: 2 }));
    const [fm3, setfm3] = useState(new FormatMoney({ symbol: '$ ', decimals: 2 }));
    const [tipodocumentoinicioseleccionado, settipodocumentoinicioseleccionado] = useState("-");
    const [vendedorinicioseleccionado, setvendedorinicioseleccionado] = useState("-");
    const [terceroinicioseleccionado, setterceroinicioseleccionado] = useState("-");
    const [tipodocumentofinseleccionado, settipodocumentofinseleccionado] = useState("-");
    const [vendedorfinseleccionado, setvendedorfinseleccionado] = useState("-");
    const [tercerofinseleccionado, settercerofinseleccionado] = useState("-");
    const [movimientoenvio, setmovimientoenvio] = useState(false);
    const [cajaenvio, setcajaenvio] = useState(false);
    const [editarorden, seteditarorden] = useState(false);
    const [ia, setia] = useState(false);

    const buscar = () => {

        setPendiente(true)
        // let options = { year: 'numeric', month: '2-digit', day: '2-digit' };

        // let _fechaInicio = fechaInicio.toLocaleDateString('es-PE', options)
        // let _fechaFin = fechaFin.toLocaleDateString('es-PE', options)
        let dt = JSON.parse(user)
        var coincidencia = ''
        const api = fetch(props.servidor + "/MovimientoApi/MovimientosElectronicos/" + fechaInicio + "/" + fechaFin + "/" + tipodocumentoinicioseleccionado + "/" + tipodocumentofinseleccionado + "/" + terceroinicioseleccionado + "/" + tercerofinseleccionado + "/" + vendedorinicioseleccionado + "/" + vendedorfinseleccionado + '?llave=' + dt.usuario.llaveempresa + '')
            .then((response) => {
                return response.ok ? response.json() : Promise.reject(response);
            })
            .then((dataJson) => {
                var data = dataJson;
                setPendiente(false)
                if (data.length < 1) {
                    Swal.fire(
                        'Opps!',
                        'No se encontraron resultados',
                        'warning'
                    )
                }
                setVentas(data);
                // var conceptos = data.reduce((array, venta) => {
                //     if (!array[venta.concepto]) {
                //         array[venta.concepto] = 0;
                //     }
                //     array[venta.concepto] += venta.total;
                //     return array;
                // }, {});

                // const conceptosarray = Object.entries(conceptos).map(([concepto, total]) => ({
                //     concepto,
                //     total,
                // }));
            }).catch((error) => {
                setVentas([]);
                Swal.fire(
                    'Opps!',
                    'No se pudo encontrar información',
                    'error'
                )
            })
    }
    const CustomDescripcion = ({ row }) => (
        <div>
            { }
            <div>
                <div style={{ fontSize: '8px' }}>
                    { }
                    {row.cufe}
                </div>
            </div>
        </div>
    );

    const CustomQr = ({ row }) => (
        <div>
            { }
            <div style={{ fontSize: '8px' }}>
                <a
                    href={row.qr}
                    target="_blank"
                >
                    { }
                    {row.qr}
                </a>
            </div>
        </div>
    );
    const CustomCliente = ({ row }) => (
        <div>
            { }
            <div>
                <div
                >
                    { }
                    {row.nombrecli}
                </div>
            </div>
        </div>
    );
    const CustomOrden = ({ row }) => (
        <div>
            { }
            <div>
                <div style={{ color: 'blue' }} onClick={() => {
                    try {

                        let dt = JSON.parse(user)
                        var url = props.servidor + '/Movimientoapi/Buscarbuscarunico/' + row.numero + '?llave=' + dt.usuario.llaveempresa + ''
                        const api = fetch(props.servidor + '/Movimientoapi/buscarunico/' + row.concepto + '/' + row.ndocumento + '?llave=' + dt.usuario.llaveempresa + '')
                            .then((response) => {
                                return response.ok ? response.json() : Promise.reject(response);
                            })
                            .then((dataJson) => {
                                setmovimientoenvio(dataJson)
                                seteditarorden(true)

                            }).catch((error) => {
                                Swal.fire(
                                    'Opps!',
                                    'No se encontro el movimiento',
                                    'error'
                                )
                            })
                    } catch (error) {
                        console.log(error)
                    }
                }}
                >
                    {row.ndocumento}
                </div>
            </div>
        </div>
    );

    const CustomCorreos = ({ row }) => (
        <div>
            { }
            <div>
                <div style={{ fontSize: '8px' }}>
                    { }
                    {row.cufe}
                </div>
            </div>
        </div>
    );
    const columns = [
        {
            name: 'Concepto',
            selector: row => row.concepto,
            sortable: true,
        },
        {
            name: 'Documento',
            selector: row => row.ndocumento,
            sortable: true,
            cell: row => <CustomOrden row={row} />,
        },
        {
            name: 'Fecha',
            selector: row => row.fecha,
            sortable: true,
            grow: 6,
        },
        {
            name: 'Cliente',
            selector: row => row.cliente,
            sortable: true,
            grow: 6,
        },
        {
            name: 'Nombre Cliente',
            selector: row => row.nombrecli,
            sortable: true,
            grow: 3,
            cell: row => <CustomCliente row={row} />,
        },
        {
            name: 'Emitida',
            selector: row => row.cufe == "" ? "no" : "si",
            sortable: true,
        },
        {
            name: 'Total',
            selector: row => fm3.from(Number(row.total + "")),
            sortable: true,
            grow: 3,
        },
        {
            name: 'Qr',
            selector: row => row.qr,
            sortable: true,
            grow: 5,
            cell: row => <CustomQr row={row} />,
        },
        {
            name: 'Cufe',
            selector: row => row.cufe,
            sortable: true,
            grow: 5,
            cell: row => <CustomDescripcion row={row} />,
        },
        {
            name: 'Correos',
            selector: row => row.cufe,
            sortable: true,
            grow: 5,
            cell: row => <CustomCorreos row={row} />,
        }
    ];
    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const exportarExcel = () => {
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.json_to_sheet(ventas);

        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        XLSX.writeFile(wb, "Reporte Existencia Productos.xlsx")
    }
    const totaltotal = () => {
        var tot = 0
        for (let i = 0; i < ventas.length; i++) {
            const element = ventas[i];
            tot = tot + element.total
        }
        return tot
    }
    const totalporconcepto = (codigo) => {
        var tot = 0
        var conceptos = ventas.filter(p => p.concepto == codigo)
        for (let i = 0; i < conceptos.length; i++) {
            const element = conceptos[i];
            tot = tot + element.total
        }
        return tot
    }
    return (
        <>
            <Row>

                <Col sm={2}>
                    <FormGroup>
                        <Label style={{ fontSize: '13px' }}>Fecha Inicio:</Label>
                        <Input bsSize="sm" type="date" className="form-control form-control-sm"
                            selected={fechaInicio}
                            value={fechaInicio}
                            onChange={(e) => setFechaInicio(e.target.value)}></Input>

                    </FormGroup>
                </Col>

                <Col sm={2}>
                    <FormGroup>
                        <Label style={{ fontSize: '13px' }}>Fecha Fin:</Label>
                        <Input bsSize="sm" type="date" className="form-control form-control-sm"
                            selected={fechaFin}
                            value={fechaFin}
                            onChange={(e) => setFechaFin(e.target.value)}></Input>


                    </FormGroup>
                </Col>
                <Col sm={2}>
                    <FormGroup>
                        <Label style={{ fontSize: '13px' }}>{tabespacio}</Label>
                        <Button style={{ backgroundColor: 'darkmagenta' }} size="sm" block onClick={() => {
                            setfiltros(true)
                        }}>
                            <i className="fa fa-search" aria-hidden="true"></i> Filtros
                        </Button>
                    </FormGroup>
                </Col>
                <Col sm={2}>
                    <FormGroup>
                        <Label style={{ fontSize: '13px' }}>{tabespacio}</Label>
                        <Button color="primary" size="sm" block onClick={buscar}>
                            <i className="fa fa-search" aria-hidden="true"></i> Buscar
                        </Button>
                    </FormGroup>
                </Col>

                <Col sm={2}>
                    <FormGroup>
                        <Label style={{ fontSize: '13px' }}>{tabespacio}</Label>
                        <Button color="success" size="sm" block onClick={exportarExcel}>
                            <i className="fa fa-file-excel" aria-hidden="true"></i> Exportar
                        </Button>
                    </FormGroup>
                </Col>
                <Col sm={3}>
                    <FormGroup>
                        <Label style={{ fontSize: '13px' }}>{tabespacio}</Label>
                        <Button color="success" size="sm" block onClick={() => {
                            setia(true)
                        }}>
                            <i className="fa fa-file-excel" aria-hidden="true"></i> Consultar Con Jerry
                        </Button>
                    </FormGroup>
                </Col>
            </Row>



            <Row>
                <Col sm={12}>
                    <Card>

                        <CardBody>
                            <Row>

                                <Col sm="12">
                                    <DataTable
                                        progressPending={pendiente}
                                        columns={columns}
                                        data={ventas}
                                        customStyles={customStyles}
                                        pagination
                                        paginationComponentOptions={paginationComponentOptions}
                                    />


                                </Col>

                            </Row>

                        </CardBody>
                    </Card>
                </Col>
                <Modal size="lg" style={{ maxWidth: '1600px', width: '95%' }} isOpen={editarorden}>

                    <ModalBody >

                        <Movimientos caja={props.caja} permisosusuario={props.permisosusuario} movimiento={movimientoenvio} cerrar={() => {
                            seteditarorden(false)
                            buscar()
                        }} editarorden={editarorden} servidor={props.servidor} />

                    </ModalBody>
                    <ModalFooter>

                        <Button size="lg" color="primary" onClick={() => {
                            seteditarorden(false)
                        }}>Cerrar</Button>
                    </ModalFooter>
                </Modal>
                <Modal size="lg" style={{ maxWidth: '1600px', width: '95%' }} isOpen={false}>


                    <ModalFooter>

                        <Button size="lg" color="primary" onClick={() => {
                            // setabrircorreosenviados(false)
                        }}>Cerrar</Button>
                    </ModalFooter>
                </Modal>
                <Filtro
                    settipodocumentoinicioseleccionado={(e) => { settipodocumentoinicioseleccionado(e) }}
                    settipodocumentofinseleccionado={(e) => { settipodocumentofinseleccionado(e) }}
                    setterceroinicioseleccionado={(e) => { setterceroinicioseleccionado(e) }}
                    settercerofinseleccionado={(e) => { settercerofinseleccionado(e) }}
                    setvendedorinicioseleccionado={(e) => { setvendedorinicioseleccionado(e) }}
                    setvendedorfinseleccionado={(e) => { setvendedorfinseleccionado(e) }}

                    tipodocumentoinicioseleccionado={tipodocumentoinicioseleccionado}
                    tipodocumentofinseleccionado={tipodocumentofinseleccionado}
                    terceroinicioseleccionado={terceroinicioseleccionado}
                    tercerofinseleccionado={tercerofinseleccionado}
                    vendedorinicioseleccionado={vendedorinicioseleccionado}
                    vendedorfinseleccionado={vendedorfinseleccionado}
                    servidor={props.servidor} verModal={filtros} cerrarModal={() => { setfiltros(false) }} />
                <Modal size="lg" style={{ maxWidth: '1600px', width: '95%' }} isOpen={ia}>
                    <ModalFooter>

                        <Button size="lg" color="primary" onClick={() => {
                            setia(false)
                        }}>Cerrar</Button>
                    </ModalFooter>
                    <ModalBody >

                        <InteligenciaArtificial promt={"Explicalo Detalladamente, se un experto financiero, contable, administrativo, etc"} servidor={props.servidor} ventas={ventas} />
                    </ModalBody>
                    <ModalFooter>

                        <Button size="lg" color="primary" onClick={() => {
                            setia(false)
                        }}>Cerrar</Button>
                    </ModalFooter>
                </Modal>
            </Row>


        </>
    )
}

export default ReporteVenta;